<script lang="ts">
    import { getContext } from 'svelte'
    import { SvelteSet } from 'svelte/reactivity'
    import { derived as sderived } from 'svelte/store'
    import type { Readable } from 'svelte/store'

    import type { GenOrder } from '../../order'
    import { toASCII, toUnicode } from 'punycode-esm'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'

    import IntCurrency from 'wdom/components/IntCurrency.svelte'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder
    const status = sderived(Order.status, ($status) => $status)
    const items = sderived(Order.items, ($items) => $items)
    let order = sderived(Order.orderStore, ($order) => $order)

    let loading = $state(false)
    let working = false

    let whoisInOrder: SvelteSet<string> = $derived(new SvelteSet($status == 'ready' ? $items.filter((i) => i.type == 'PRIVACY').map((i) => i.meta.a_name) : []))
    let domainsWithoutWhoisInOrder: Set<string> = $derived(new SvelteSet($status == 'ready' ? $items.filter((i) => i.type == 'DOMAIN' && !whoisInOrder.has(i.meta.a_name) && prices[i.meta.a_name.split('.').pop()] != null).map((i) => i.meta.a_name) : []))

    interface EligibleDomain {
        id: string
        name: string
        price: number
    }
    let results: string[] = $state([])
    let effResults: string[] = $derived(results.filter((i) => !whoisInOrder.has(i)))

    let prices: { [key: string]: number } = $state({})

    function getPrice(name: string, prices: { [key: string]: number }) {
        const tld = name.split('.').pop()
        return tld ? prices[tld] : null
    }

    async function load() {
        loading = true

        results = []

        try {
            const r = await simpleFetch('GET', `/json/ecom/1/eligible-whois-privacy-domains/${$order.owner}`)
            const anames = r.data.items.map((i: EligibleDomain) => toASCII(i.name))
            anames.sort((a: string, b: string) => a.localeCompare(b))
            results = anames
            prices = r.data.whois_prices
        } catch (e) {
            console.error('Could not load whois information:', e)
            notify({
                type: 'danger',
                title: 'Information whois',
                text: 'L’information (prix et domaines éligibles) par rapport au Whois Privacy n’a pas pu être chargée.',
            })
        }
        loading = false
    }

    let loaded = false
    $effect(() => {
        if (!loaded && $status == 'ready') {
            loaded = true
            load()
        }
    })

    let toggling: false | string = $state(false)
    async function toggleWhois(aname: string) {
        toggling = aname

        const url = `/json/ecom/1/order/${$orderId}/privacy`
        try {
            const r = await simpleFetch(whoisInOrder.has(aname) ? 'DELETE' : 'PUT', url, { domain: aname })
            Order.loadGenericResponse(r.data)
        } catch (e: any) {
            console.error('Failed to toggle privacy:', e)
            let msg = `La présence du Whois Privace pour « ${aname} » n’a pas pu être changée`
            notify({
                type: 'danger',
                title: 'Toggle Whois',
                text: msg + (e && e.data && e.data.error ? ` : ${e.data.error}` : '.'),
            })
        }
        toggling = false
    }
</script>

<div id="order-whois">
    {#if !domainsWithoutWhoisInOrder.size && !effResults.length}
        <p>Rien à afficher</p>
    {/if}

    {#if domainsWithoutWhoisInOrder.size}
        <p><strong>Domaines dans la commande :</strong></p>
        <div style="display: flex; flex-wrap: wrap; gap: .5ex;">
            {#each [...domainsWithoutWhoisInOrder] as aname}
                <button type="button" class="btn btn-outline-secondary" onclick={() => toggleWhois(aname)}>{toUnicode(aname)} (<IntCurrency value={getPrice(aname, prices)} nullIsZero={false} nullValue={'??'} />)</button>
            {/each}
        </div>
    {/if}
    {#if effResults.length}
        <p style={domainsWithoutWhoisInOrder.size ? 'margin-top: 1ex;' : ''}><strong>Domaines éligibles sur le compte :</strong></p>
        <div style="display: flex; flex-wrap: wrap; gap: .5ex;">
            {#each effResults as aname}
                <button type="button" class="btn btn-outline-secondary" disabled={working || loading} onclick={() => toggleWhois(aname)} class:btn-info={toggling == aname} class:active={whoisInOrder.has(aname)}>
                    {toUnicode(aname)}
                    (<IntCurrency value={getPrice(aname, prices)} nullIsZero={false} nullValue={'??'} />)
                </button>
            {/each}
        </div>
    {/if}
</div>
